import { useState, useEffect } from 'react';
import librosContablesService from '../services/librosContablesService';

/**
 * Meses cerrados del año, como mapa { [mes]: cerrado } con mes de 1 a 12.
 * Las páginas de carga lo usan para deshabilitar la fila completa de un mes cerrado:
 * un mes cerrado no admite cargas ni consultas.
 */
const useMesesCerrados = (id_company, year, token) => {
    const [mesesCerrados, setMesesCerrados] = useState({});

    useEffect(() => {
        setMesesCerrados({});
        if (!id_company || !year || !token) return;
        librosContablesService.getEstadoCierre(id_company, year, token)
            .then(setMesesCerrados)
            .catch(err => console.error('Error obteniendo el estado de cierre', err));
    }, [id_company, year, token]);

    return mesesCerrados;
};

export default useMesesCerrados;
